import React from "react";
import { Answer } from "./utils/sortCorrectAndIncorrectAnswers";

const AnswerCategory = ({
  name,
  answers,
  index,
}: {
  index: number;
  name: string;
  answers: Answer[];
}) => {
  const givenAnswers = answers.filter(({ givenCategory }) => {
    return givenCategory === index;
  });

  const missedAnswers = answers.filter(({ correctCategory, givenCategory }) => {
    return correctCategory === index && givenCategory !== index;
  });

  console.log({
    givenAnswers,
    missedAnswers,
    answers,
  });

  return (
    <>
      <div className={`book-holder`}>
        {givenAnswers.map((answer: Answer) => {
          return (
            <img
              src={answer.img}
              id={answer.id}
              key={answer.id}
              draggable={true}
              className={
                answer.givenCategory !== answer.correctCategory
                  ? "incorrect-guess"
                  : undefined
              }
            />
          );
        })}
      </div>
      <div>
        {missedAnswers.map((answer) => {
          return (
            <p>
              {answer.bookTitle} - {answer.reason}
            </p>
          );
        })}
      </div>
    </>
  );
};

export default AnswerCategory;
